'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    background-color: #fff;\n    border-radius: 50%;\n    box-shadow: 0 0 8px 0 rgba(81, 88, 97, 0.2);\n    height: 28px;\n    width: 28px;\n    \n    .react-bodymovin-container {\n        height: 28px;\n        position: relative;\n        width: 28px;\n    }\n'], ['\n    background-color: #fff;\n    border-radius: 50%;\n    box-shadow: 0 0 8px 0 rgba(81, 88, 97, 0.2);\n    height: 28px;\n    width: 28px;\n    \n    .react-bodymovin-container {\n        height: 28px;\n        position: relative;\n        width: 28px;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _HeartAnimationFave = require('./HeartAnimationFave');

var _HeartAnimationFave2 = _interopRequireDefault(_HeartAnimationFave);

var _HeartAnimationUnFave = require('./HeartAnimationUnFave');

var _HeartAnimationUnFave2 = _interopRequireDefault(_HeartAnimationUnFave);

var _colors = require('../../styles/colors');

var _colors2 = _interopRequireDefault(_colors);

var _Heart = require('./Heart');

var _Heart2 = _interopRequireDefault(_Heart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FavoritingHeartCircle = _styledComponents2.default.div(_templateObject);

var FavoritingHeart = function (_React$Component) {
    _inherits(FavoritingHeart, _React$Component);

    function FavoritingHeart(props) {
        _classCallCheck(this, FavoritingHeart);

        var _this = _possibleConstructorReturn(this, (FavoritingHeart.__proto__ || Object.getPrototypeOf(FavoritingHeart)).call(this, props));

        _this.state = {
            unfavoritingAnimationVisible: false,
            favoritingAnimationVisible: false
        };
        return _this;
    }

    _createClass(FavoritingHeart, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                FavoritingHeartCircle,
                null,
                _react2.default.createElement(
                    'div',
                    { onClick: function onClick() {
                            if (_this2.props.isUserLoggedIn) {
                                if (_this2.props.isFavorited) {
                                    _this2.setState({ unfavoritingAnimationVisible: true });
                                } else {
                                    _this2.setState({ favoritingAnimationVisible: true });
                                }
                            }
                        } },
                    this.state.unfavoritingAnimationVisible ? _react2.default.createElement(_HeartAnimationUnFave2.default, { autoplay: true }) : null,
                    this.state.favoritingAnimationVisible ? _react2.default.createElement(_HeartAnimationFave2.default, { autoplay: true }) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'heart-static' },
                        _react2.default.createElement(_Heart2.default, {
                            circleSize: '28px',
                            heartSize: '18px',
                            heartColor: _colors2.default.secondaryLadyBug,
                            isFavorited: this.props.isFavorited,
                            padding: this.props.padding
                        })
                    )
                )
            );
        }
    }]);

    return FavoritingHeart;
}(_react2.default.Component);

exports.default = FavoritingHeart;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Favoriting/FavoritingHeart.js
// module id = 472
// module chunks = 168707334958949